// import "core-js/fn/array/for-each";
// import "core-js/fn/array/from";
import 'core-js/fn/array/find';
import 'core-js/fn/object/assign';
import 'core-js/fn/object/entries';

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function(callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

// @https://stackoverflow.com/a/37616104
Object.from = arr =>
  Object.assign(
    ...arr.map(([k, v]) => ({
      [k]: v,
    }))
  );

Object.filter = (obj, predicate) => Object.from(Object.entries(obj).filter(predicate) || []);



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/compat.js